import { Box, Button, Tabs, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

import { regularTextColor } from 'assets/styles/_palette';

export const Profile = styled(Box)(({ theme }) => ({
	...flexMixin({ justify: 'flex-start', direction: 'column', gap: 40 }),
	margin: '0 auto',
	width: '100%',
	height: '100%',
	padding: '28px !important',
	'@media (max-width: 1536px)': {
		padding: '28px 0',
	},
	[theme.breakpoints.down('sm')]: {
		gap: 24,
		padding: '16px 0',
	},
	[theme.breakpoints.down('xs')]: {
		gap: 16,
		padding: '12px 0',
	},
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
	marginTop: '40px',
	padding: '10px 16px',
	width: '100%',
	borderRadius: '8px',
	background: '#4786FF',
	textTransform: 'none',
	fontSize: '16px',
	fontWeight: '700',
	lineHeight: '157%',
	letterSpacing: '0.1px',
	color: '#FFF',
	[theme.breakpoints.down('sm')]: {
		marginTop: '24px',
		padding: '10px 12px',
		fontSize: '14px',
	},
	[theme.breakpoints.down('xs')]: {
		marginTop: '16px',
		padding: '8px 12px',
		fontSize: '14px',
	},
	'&.Mui-disabled': {
		background: '#B5CFFF',
		color: '#FFF',
	},
}));

export const TabContent = styled(Box)(({ theme }) => ({
	...flexMixin({ justify: 'flex-start', direction: 'column', gap: 24 }),
	padding: '24px',
	flexGrow: 1,
	height: '100%',
	width: '100%',
	[theme.breakpoints.down('sm')]: {
		gap: 24,
	},
	[theme.breakpoints.down('xs')]: {
		gap: 16,
	},
}));

export const TabsButtons = styled(Tabs)(({ theme }) => ({
	overflow: 'visible',
	minHeight: 'auto',
	'& .MuiTabs-flexContainer': {
		...flexMixin({ gap: 12 }),
		flexWrap: 'wrap',
		[theme.breakpoints.down('sm')]: {
			gap: 8,
		},
		[theme.breakpoints.down('xs')]: {
			gap: 6,
		},

		'& button': {
			boxSizing: 'border-box',
			padding: '8px 16px',
			textTransform: 'none',
			color: regularTextColor,
			fontSize: '16px',
			fontWeight: '400',
			lineHeight: '150%',
			letterSpacing: '0',
			borderRadius: '8px',
			minWidth: 'auto',
			flex: '0 1 auto',
			whiteSpace: 'nowrap',
			[theme.breakpoints.down('sm')]: {
				padding: '6px 12px',
				fontSize: '14px',
			},
			[theme.breakpoints.down('xs')]: {
				padding: '6px 10px',
				fontSize: '12px',
			},

			'&.Mui-selected': {
				background: '#ECF3FF',
				color: '#4786FF',
				fontWeight: '700',
			},
		},
	},

	'& .MuiTabs-indicator': {
		display: 'none',
	},
}));
